var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftBlue2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 479,
    viewBox: "0 0 179 479",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.1189 1.28406C55.9919 27.0203 115.463 50.3965 177.693 70.6258V440.261C115.463 451.387 55.9919 464.087 1.1189 478.023V1.28406Z",
    fill: "#00C8D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.63024 2.18346C56.2989 27.6949 115.259 50.9587 177.183 71.188V439.924C115.259 450.938 56.2989 463.525 1.63024 477.461V2.18346ZM0.608398 0.497681V478.922C55.788 464.874 115.157 452.062 178.205 440.936V70.4013C115.259 49.7224 55.788 26.3463 0.608398 0.497681Z",
    fill: "#00C8D5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBlue2);
export default __webpack_public_path__ + "static/media/LeftBlue2.81f4b89a9efca0787241ba35ab7f77a6.svg";
export { ForwardRef as ReactComponent };